import { EntityStoreModule } from './entity-store/entity-store.module';
import { CornerInfoModule } from './corner-info/corner-info.module';
import { MultiCanvasModule } from './multi-canvas/multi-canvas.module';
import { ImageStoreModule } from './image-store/image-store.module';
import { NgThreeModule } from './ng3/ng3.module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageWComponent } from './image-w.component';
import { ImageSliceShowModule } from './image-slice-show/image-slice-show.module';

@NgModule({
  declarations: [ImageWComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    NgThreeModule,
    ImageSliceShowModule,
    ImageStoreModule,
    MultiCanvasModule,
    CornerInfoModule,
    EntityStoreModule,

  ],
  exports: [
    ImageWComponent,
    ImageStoreModule,
    MultiCanvasModule,
    ImageSliceShowModule,
    NgThreeModule,
    CornerInfoModule,
    EntityStoreModule
  ],
})
export class ImageWModule {}
